var _path, _path2, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUniqueViewsIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.84 14.2383C13.62 14.2383 13.43 14.2783 13.27 14.3583L10.36 15.6783C10.12 15.7983 10 15.9783 10 16.2183V17.9583C10 18.0983 10.03 18.2083 10.09 18.2883C10.17 18.3683 10.27 18.4083 10.39 18.4083C10.45 18.4083 10.5 18.3983 10.54 18.3783L13.33 17.5983C13.47 17.5583 13.54 17.6083 13.54 17.7483V34.7583C13.54 35.0783 13.7 35.2383 14.02 35.2383H16.54C16.86 35.2383 17.02 35.0783 17.02 34.7583V14.7183C17.02 14.3983 16.86 14.2383 16.54 14.2383H13.84Z",
    fill: "#522D56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8216 25.3811C40.3776 25.6463 40.9605 25.0593 40.5874 24.5691C38.1214 21.3295 34.2242 19.2383 29.8387 19.2383C25.4531 19.2383 21.556 21.3294 19.0901 24.569C18.717 25.0591 19.2998 25.6462 19.8558 25.381C21.3238 24.6806 22.9556 24.1305 24.704 23.7631C24.468 24.3761 24.3387 25.0421 24.3387 25.7383C24.3387 28.7758 26.8011 31.2383 29.8387 31.2383C32.8762 31.2383 35.3387 28.7758 35.3387 25.7383C35.3387 25.0421 35.2093 24.3762 34.9733 23.7631C36.7217 24.1306 38.3536 24.6807 39.8216 25.3811ZM33.3387 25.7383C33.3387 27.6713 31.7716 29.2383 29.8387 29.2383C27.9057 29.2383 26.3387 27.6713 26.3387 25.7383C26.3387 23.8053 27.9057 22.2383 29.8387 22.2383C31.7716 22.2383 33.3387 23.8053 33.3387 25.7383Z",
    fill: "#522D56"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 44.2383,
    x2: 44,
    y2: 44.2383,
    stroke: "#522D56",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniqueViewsIconSelected);
export default __webpack_public_path__ + "static/media/UniqueViews_icon_selected.949d595310e7ffe3d71a3b6323e2ea66.svg";
export { ForwardRef as ReactComponent };